export function isIosDevice() {
  const isiOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  const isiPadOS = /macintosh/i.test(window.navigator.userAgent) && navigator.maxTouchPoints > 2;
  const isStandalone = 'standalone' in window.navigator && window.navigator.standalone;

  return (isiOS || isiPadOS) && !isStandalone;
}
